import React from "react";
import { Table } from "reactstrap";
import $ from "jquery";
import "datatables.net-bs4";
import "bootstrap";
import Select from "react-select";
import ReactDOM from "react-dom";
import "../../assets/scss/react/_buttons.scss"
export default class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.dataTable = null;
    this.extraOptions = { stateSave: true };
    this.reactColHeaders = [];
  }

  componentDidMount() {
    $('[data-toggle="tooltip"]').tooltip();
    if (this.dataTable !== null) return;

    this.$el = $(this.el);
    
    if (this.props.addinvoiceButton) {
      this.props.addinvoiceButton.forEach((button) => {
        this.props.columns.push({
          title: "",
          data: null,
          sortable: false,
          searchable: false,
          defaultContent: !!button.icon
            ? `<button class='btn text-info ncentiva-${
                button.name
              }-btn' style='${button.style}' ${
                button.props ?? ""
              }><i class='${button.icon}'></i></button>`
            : `<button class='btn btn-primary ncentiva-${
                button.name
              }-btn' style="${button.style}" ${
                button.props ?? ""
              }>${button.name}</button>`,
          width: "2%",
        });
      });
    }

    if (this.props.addCustomButtons) {
      this.props.addCustomButtons.forEach((button) => {
        this.props.columns.push({
          title: "",
          data: null,
          sortable: false,
          searchable: false,
          defaultContent: !!button.icon
            ? `<button class='btn text-info ncentiva-${
                button.name
              }-btn' style='${button.style}' ${button.tooltip} ${
                button.props ?? ""
              }><i class='${button.icon}'></i></button>`
            : `<button class='btn btn-primary ncentiva-${
                button.name
              }-btn' style="${button.style}" ${button.props ?? ""}>${
                button.innerHTML
              }</button>`,
          width: "2%",
        });
      });
    }

    
    
    if (this.props.addDashButton) {
      this.props.columns.push({
        title: "",
        data: null,
        sortable: false,
        searchable: false,
        defaultContent:
          "<button class='btn text-info ncentiva-dashboard-btn' style='padding: 5px 10px; background: transparent'><i class='fas fa-info-circle fa-2x'></i></button>",
        width: "2%",
      });
    }

    if (this.props.addEditButton) {
      this.props.columns.push({
        title: "",
        data: null,
        sortable: false,
        searchable: false,
        defaultContent: `<button class=' btn text-white ncentiva-edit-btn' style='padding: 5px 10px; background: #FFAD31'><i class='${
          this.props.addEditButton.viewMode ? "fas fa-eye" : "bi bi-pen"
        }'></button>`,
        width: "2%",
      });
    }

if (this.props.addEditButtonTwo) {
      this.props.columns.push({
        title: "",
        data: null,
        sortable: false,
        searchable: false,
        defaultContent: `<button class=' btn text-white ncentiva-edit-btn' style='padding: 5px 10px; background: #FFAD31'><i class='${
          this.props.addEditButtonTwo.viewMode ? "fas fa-eye" : "bi bi-pen"
        }'></button>`,
        width: "2%",
      });
    }
    // <i className="bi bi-sort-down"></i>

    if (this.props.resendEmail) {
			this.props.columns.push({
				title: '',
				data: null,
				sortable: false,
				searchable: false,
				defaultContent: `<button data-contact-id="{{contactId}}" class='btn text-info ncentiva-primary-btn' name='Resend-Email' style='padding: 5px 10px;background: transparent' ">
        <i style="font-size:22px; cursor:pointer" class="btn-resend-mail fa">&#xf079;</i></button>`,
				width: "2%"
			});
    }
    if(this.props.addDeleteButton) {
       this.props.columns.push({
        title: "",
        data: null,
        sortable: false,
        searchable: false,
        defaultContent:
        "<button class='btn text-danger ncentiva-removeSupplierBrand-btn' style='padding: 5px 10px; background: transparent'><i class='fas fa-times fa-2x'></button>",
        width: "2%",
      });
    }
    if (this.props.addRemoveButton) {
      this.props.columns.push({
        title: "",
        data: null,
        sortable: false,
        searchable: false,
        defaultContent:
          "<button class='btn text-white ncentiva-delete-btn' style='padding: 5px 10px; background: #f5365c'><i class='bi bi-x-lg'></button>",
        width: "2%",
      });
    }
    if (this.props.addCheckButton) {
      this.props.addCheckButton.forEach((button) => {
        this.props.columns.push({
          title: "",
          data: null,
          sortable: false,
          searchable: false,
          // defaultContent: `<button class='btn btn-primary ' style="${{
          //   padding: "5px 10px",
          // }}" ${button.props ?? ""}> select</button>`,
          width: "2%",
          // defaultContent: '<button class="toggle-btn">Toggle</button>',
          defaultContent: `<input type='radio' class='btn  ncentiva-delete-btn' style='padding: 5px 10px; background: transparent'/>`,
        });
      });
    }

    const hidebodyScroll = () =>{
      const body = document.querySelector('body');
      body.classList.remove('perfect-scrollbar-on');
    }
    const showBodyScroll = () =>{
      const body = document.querySelector('body');
      body.classList.add('perfect-scrollbar-on');
    }

    if (this.props.CustomedeleteButton) {
      this.props.CustomedeleteButton.forEach((button) => {
        this.props.columns.push({
          title: "",
          data: null,
          sortable: false,
          searchable: false,
          defaultContent: `<button class='btn btn-primary' style="${{
            padding: "5px 10px",
          }}" ${button.props ?? ""}> delete</button>`,
          width: "2%",
          // defaultContent: `<input type='radio' class='btn  ncentiva-delete-btn' style='padding: 5px 10px; background: transparent'/>`,
        });
      });
    }

    if (this.props.onChildRowChange) {
      this.$el.on("childRow.dt", this.props.onChildRowChange);
    }
    const props = this.props;
    const colFilters = [];

    function onInitComplete() {
      if (props.enableSelectFilters) {
        const header2 = document.createElement("tr");
        this.api()
          .column(0)
          .header()
          .parentElement.parentElement.append(header2);
        this.api()
          .columns()
          .every(function () {
            const column = this;
            const cell = document.createElement("th");
            cell.style.textTransform = "none";
            cell.style.fontWeight = "normal";
            cell.style.fontSize = "12px";
            cell.style.padding = "0 2px";
            cell.style.borderRadius = "0";

            header2.append(cell);
            if (column.init().columns[column.index()].searchable) {
              function onChange(selectedOptions) {
                const searchOpts = [];
                selectedOptions.forEach((item) => {
                  if (typeof item.value !== "string")
                    item.value = item.value.toString();
                  searchOpts.push(
                    `^${$.fn.dataTable.util.escapeRegex(item.value)}$`
                  );
                });
                let val = null;
                if (searchOpts.length > 0) {
                  val = `(${searchOpts.join("|")})`;
                }
                column.search(val ?? "", true, false).draw();
              }

              const colId = `dtcf-${Date.now()}-${column.index()}`;
              const select = (
                <Select
                  id={colId}
                  isMulti={true}
                  placeholder="Search"
                  onChange={onChange}
                  onFocus={hidebodyScroll}
                  onBlur={showBodyScroll}
                  options={[]}
                  styles={{
                    control: (styles) => ({ ...styles, minHeight: "20px" }),
                  }}
                />
              );
              colFilters[column.index()] = select;
              const colJQ = $(cell);
              colJQ.click((e) => {
                e.stopPropagation();
              });
              colJQ.appendTo($(cell));
              ReactDOM.render(select, colJQ[0]);
            }
            return true;
          });
      }
      if (props.onInit && typeof props.onInit === "function") {
        props.onInit();
      }
    }

    this.extraOptions.initComplete = onInitComplete;

    this.dataTable = this.$el.DataTable({
      data: this.props.data,
      columns: this.props.columns,
      ...this.extraOptions,
      ...this.props.options,
    });

    const dt = this.dataTable;

    if (this.props.enableSelectFilters) {
      this.$el.on("draw.dt", () => {
        dt.columns().every(function () {
          const column = this;
          const colDef = column.init().columns[column.index()];

          if (colDef.searchable) {
            if (colFilters[column.index()]) {
              const currencyToNumber = (string) => {
                return Number(string.replace(/[^0-9.-]+/g, ""));
              };
              const opts = colFilters[column.index()].props.options;
              opts.splice(0, opts.length);
              let data = column.data().unique();

              if (colDef?.type === "date")
                data = data.sort(
                  (a, b) => new Date(b).getTime() - new Date(a).getTime()
                );
              else if (colDef?.type === "currency")
                data = data.sort(
                  (a, b) => currencyToNumber(b) - currencyToNumber(a)
                );
              else if (colDef?.type === "number")
                data = data.sort((a, b) => Number(b) - Number(a));
              else {
                data = data.sort();
              }
              data.each((item) => {
                if (colDef.render) {
                  if (colDef.renderForSelect) {
                    opts.push({
                      label: colDef.renderForSelect(item).label,
                      value: colDef.renderForSelect(item).value,
                    });
                  } else {
                    opts.push({
                      label: colDef.render(item),
                      value: colDef.render(item),
                    });
                  }
                } else opts.push({ label: item, value: item });
                return true;
              });
            }
          }
          return true;
        });
      });
    }

    if (this.props.addRemoveButton && this.props.addRemoveButton.callback) {
      const cb = this.props.addRemoveButton.callback;
      this.$el
        .find("tbody")
        .on("click", "button.ncentiva-delete-btn", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const row = dt.row($(this).parents("tr"));
          cb(row);
        });
    }
    if (this.props.addDeleteButton && this.props.addDeleteButton.callback) {
      const cb = this.props.addDeleteButton.callback;
      this.$el
        .find("tbody")
        .on("click", "button.ncentiva-removeSupplierBrand-btn", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const row = dt.row($(this).parents("tr"));
          cb(row);
        });
    }

    if (this.props.addEditButton && this.props.addEditButton.callback) {
      const cb = this.props.addEditButton.callback;
      this.$el
        .find("tbody")
        .on("click", "button.ncentiva-edit-btn", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const row = dt.row($(this).parents("tr"));
          cb(row);
        });
    }
    if (this.props.addEditButtonTwo && this.props.addEditButtonTwo.callback) {
      const cb = this.props.addEditButtonTwo.callback;
      this.$el
        .find("tbody")
        .on("click", "button.ncentiva-edit-btn", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const row = dt.row($(this).parents("tr"));
          cb(row);
        });
    }
    if (this.props.resendEmail && this.props.resendEmail.callback) {
			const cb = this.props.resendEmail.callback;
			this.$el.find('tbody').on('click', '.ncentiva-primary-btn', function (e)
			{
				e.preventDefault();
				e.stopPropagation();
				const row = dt.row($(this).parents('tr'));
				cb(row);
			});
		}
    if (this.props.addDashButton && this.props.addDashButton.callback) {
      const cb = this.props.addDashButton.callback;
      this.$el
        .find("tbody")
        .on("click", "button.ncentiva-dashboard-btn", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const row = dt.row($(this).parents("tr"));
          cb(row);
        });
    }
    if (this.props.addCheckButton) {
      this.props.addCheckButton.forEach((button) => {
        if (button.callback) {
          const cb = button.callback;
          this.$el
            .find("tbody")
            .on("click", `input.ncentiva-${button.name}-btn`, function (e) {
              e.preventDefault();
              e.stopPropagation();
              const row = dt.row($(this).parents("tr"));
              cb(row);
            });
        }
      });
    }

    if (this.props.addCustomButtons) {
      this.props.addCustomButtons.forEach((button) => {
        if (button.callback) {
          const cb = button.callback;
          this.$el
            .find("tbody")
            .on("click", `button.ncentiva-${button.name}-btn`, function (e) {
              e.preventDefault();
              e.stopPropagation();
              const row = dt.row($(this).parents("tr"));
              cb(row);
            });
        }
      });
    }

    if (this.props.adddropdownOnchange) {
      const { callback, selector } = this.props.adddropdownOnchange;
      this.props.adddropdownOnchange.forEach((button)=>{
        if(button.callback){
          const cb = button.callback;
        
            // Attach event listener to the select element within the DataTable
      this.$el.find("tbody").on("change", button.selector, function (e) {
        e.preventDefault();
        e.stopPropagation();
    
        // Get the selected value
        const selectedValue = $(this).val();
        const closestRow = dt.row($(this).closest("tr"));
        
    
        // Call the callback function with the selected value
        cb(selectedValue,closestRow);
      });
    }
      })
    }

    if (this.props.addmaindropdown) {
      this.props.addmaindropdown.forEach((dropdown) => {
        if (dropdown.callback && dropdown.selector) {
          // const { callback, selector } = dropdown;
          const cb = dropdown.callback;
          // Attach event listener to the select element within the DataTable
          this.$el.find("tbody").on("change", dropdown.selector, function () {
            // e.preventDefault();
            // e.stopPropagation();
        
            // Get the selected value
            const selectedValue = $(this).val();
            const closestRow = dt.row($(this).closest("tr"));
            
            // Call the callback function with the selected value
            cb(selectedValue, closestRow);
          });
        }
      });
    }

    if (this.props.addinvoiceButton) {
      this.props.addinvoiceButton.forEach((button) => {
        if (button.callback) {
          const cb = button.callback;
          this.$el
            .find("tbody")
            .on("click", `button.ncentiva-${button.name}-btn`, function (e) {
              e.preventDefault();
              e.stopPropagation();
              const row = dt.row($(this).parents("tr"));
              cb(row);
            });
        }
      });
    }
    
    if (this.props.addBtnsFromData) {
      this.props.addBtnsFromData.forEach((button) => {
        if (button.callback) {
          const cb = button.callback;
          this.$el.find("tbody").on("click", button.selector, function (e) {
            e.preventDefault();
            e.stopPropagation();
            const row = dt.row($(this).parents("tr"));
            cb(row);
          });
        }
      });
    }

    if (this.props.addCancelButton) {
      this.props.addCancelButton.forEach((button) => {
          if (button.callback) {
              const cb = button.callback;
              this.$el.find("tbody").on("click", button.selector, function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  const row = dt.row($(this).parents("tr"));
                  cb(row);
              });
          }
      });
  }
  
  if (this.props.addDownloadData) {
    this.props.addDownloadData.forEach((button) => {
        if (button.callback) {
            const cb = button.callback;
            this.$el.find("tbody").on("click", button.selector, function (e) {
                e.preventDefault();
                e.stopPropagation();
                const row = dt.row($(this).parents("tr"));
                cb(row);
            });
        }
    });
}

    
    if (this.props.addDownloadBts) {
      this.props.addDownloadBts.forEach((button) => {
        if (button.callback) {
          const cb = button.callback;
          this.$el.find("tbody").on("click", button.selector, function (e) {
            e.preventDefault();
            e.stopPropagation();
            const row = dt.row($(this).parents("tr"));
            cb(row);
          });
        }
      });
    }

    if (this.props.addPurchaserBts) {
      this.props.addPurchaserBts.forEach((button) => {
        if (button.callback) {
          const cb = button.callback;
          this.$el.find("tbody").on("click", button.selector, function (e) {
            e.preventDefault();
            e.stopPropagation();
            const row = dt.row($(this).parents("tr"));
            cb(row);
          });
        }
      });
    }

    

    
  } 

  

  

  componentWillUnmount() {
    if (this.dataTable !== null) this.dataTable.destroy(true);
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return false;
  }

  search = (value) => {
    this.dataTable.search(value).draw();
  };

  clearSearch = () => {
    this.dataTable.columns().search("").draw();
  };

  addRow(data) {
    if (data !== null) this.dataTable.row.add(data).draw();
  }

  render() {
    let style = { width: "100%" };
    let className = "";
    if (!!this.props.className) className = this.props.className;
    return (
      
      <Table
        onClick={this.props.onSelectRow}
        innerRef={(el) => (this.el = el)}
        responsive={this.props.responsive || false}
        style={style}
        className={className}
      />
   
    );
  }
}
